import React, { Ref, useCallback, useEffect, useRef, useState } from 'react';
import { Select, Spin, message, InputNumber, FormInstance } from 'antd';
import { httpAchievementSave, httpAchievementDateList, httpAchievementUpdate } from '@/services/customerServices';
import { SDrawerOrModal, SGeneralForms, STriggerModal } from 'shj-components';
import dayjs from "dayjs";

const { Option } = Select;

interface Props {
  id?: number;
  setVisible: (value: boolean) => void;
  company: React.MutableRefObject<any>;
  category: React.MutableRefObject<any>;
  visible: boolean;
  listRef: any;
  editData: object & { performanceCycleMonthId: string | number };
}

const AddOrEdit: React.FC<Props> = ({ editData, id, visible, setVisible, listRef, company, category }: Props) => {
  console.log(company,'sss')
  const [monthYear, setMonthYear] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const formRef: Ref<any> = useRef()

  const onFinish = async (value: any) => {
    const _value = { ...value };
    _value.id = id;
    if (!id) {
      _value.performanceCycleMonthId = _value.yearMonth.split('*')[1];
      _value.yearMonth = _value.yearMonth.split('*')[0];
      setLoading(true);
      await httpAchievementSave(_value).then(() => {
        message.success('操作成功');
        setVisible(false);
        listRef.current.reload();
        const form: FormInstance = formRef.current?.onFormRef()
        form.resetFields()
      }).finally(() => {
        setLoading(false);
      })
    } else {
      _value.performanceCycleMonthId = editData.performanceCycleMonthId;
      setLoading(true);
      await httpAchievementUpdate(_value).then(() => {
        message.success('操作成功');
        setVisible(false);
        listRef.current.reload();
        const form: FormInstance = formRef.current?.onFormRef()
        form.resetFields()
      }).finally(() => {
        setLoading(false);
      })
    }

  };

  const onOk = () => {
    const form = formRef.current?.onFormRef()
    form.validateFields().then((value: any) => {
      onFinish(value)
    })
  };
  const onCancel = useCallback(() => {
    const form: FormInstance = formRef.current?.onFormRef()
    form.resetFields()
    setVisible(false);
  }, []);

  const onChange = async (val: string, type: string) => {
    const form = formRef.current?.onFormRef()
    form.setFieldsValue({
      yearMonth: null
    })
    let _category: string | undefined = undefined;
    let _companyId: string | undefined = undefined;
    if (type == 'category') {
      _companyId = form.getFieldValue('companyId');
      _category = val;
    } else {
      _category = form.getFieldValue('category');
      _companyId = val;
    }
    if (!_category || !_companyId) return;
    setLoadingData(true);
    try {
      const resData: any = await httpAchievementDateList({
        category: _category,
        companyId: _companyId,
      })
      resData[0]?.suitCompanys?.includes(_companyId) && setMonthYear(resData || []);
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoadingData(false);
    }
  };
  useEffect(() => {
    const form = formRef.current?.onFormRef()
    if (editData?.id) {
      form.setFieldsValue(editData);
    } else {
      form.setFieldsValue({});
    }
  }, [editData]);

  useEffect(() => {
    setMonthYear([]);
  }, [visible]);

  return (
    <SDrawerOrModal
      title={id ? '编辑' : '新增'}
      // destroyOnClose={true}
      // forceRender
      // maskClosable
      // confirmLoading={loading}
      onCancel={onCancel}
      onOk={onOk}
      // cancelText="取消"
      open={visible}
    >
      <Spin spinning={loadingData} delay={100}>
        <SGeneralForms
          layout="vertical"
          onFinish={onFinish}
          ref={formRef}
          configs={[
            {
              title: '',
              formItem: [
                {
                  label: '目标类型',
                  name: 'category',
                  required: true,
                  spanCol: 24,
                  labelCol: {
                    span: 24,
                  },
                  children: (
                    <Select
                      disabled={!!id}
                      placeholder="请选择"
                      onChange={(value: string) => {
                        onChange(value, 'category');
                      }}
                      allowClear
                      showSearch
                      filterOption={(input, option: any) => {
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }}
                    >
                      {category.current && category.current?.map((item: any) => (
                        <Option key={item.priKey} value={item.priKey}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  )
                },
                {
                  label: '门店',
                  name: 'companyId',
                  required: true,
                  spanCol: 24,
                  children: (
                    <Select
                      disabled={!!id}
                      placeholder="请选择"
                      onChange={(value: string) => {
                        onChange(value, 'companyId');
                      }}
                      allowClear
                      showSearch
                      filterOption={(input, option: any) => {
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }}
                    >
                      {company.current &&
                        company.current.map((item: any) => (
                          <Option key={item.orgId} value={item.orgId}>
                            {item.companyName}
                          </Option>
                        ))}
                    </Select>
                  )
                },
                {
                  label: '年月',
                  name: 'yearMonth',
                  spanCol: 24,
                  required: true,
                  children: (
                    <Select disabled={!monthYear.length || !!id} placeholder="请选择">
                      {monthYear && monthYear.map((item: any, index: number) => (
                        <Option
                          key={index}
                          value={
                            item.year ? dayjs(item.year + (item.month?.length <= 1 ? '-0' : '-') + item.month, 'YYYY-MM').format('YYYY-MM') + '*' + item.id : ''
                          }
                        >
                          {item.year ? dayjs(item.year + (item.month?.length <= 1 ? '-0' : '-') + item.month, 'YYYY-MM').format('YYYY-MM') : '时间格式出错'}
                        </Option>
                      ))}
                    </Select>
                  )
                },
                { label: '战略目标（万）', spanCol: 24, required: true, name: 'performanceObjectivesAmount', children: <InputNumber placeholder="请输入" style={{ width: '100%' }} min={0.001} max={999999999999} precision={3}/> },
                { label: '理想目标（万）', spanCol: 24, required: true, name: 'pkTargetAmount', children: <InputNumber placeholder="请输入" style={{ width: '100%' }} min={0.001} max={999999999999} precision={3}/> }
              ]
            }
          ]}
        />
      </Spin>
    </SDrawerOrModal>
  );
};

export default AddOrEdit;
